import type { ComponentPropsWithoutRef } from 'react'
import { Loader2 } from 'lucide-react'
import { Button } from './button'

type LoadingButtonProps = ComponentPropsWithoutRef<typeof Button> & {
  loading?: boolean
  loadingText?: string
}

export function LoadingButton({
  loading,
  loadingText,
  children,
  disabled,
  ...props
}: LoadingButtonProps) {
  return (
    <Button disabled={loading ?? disabled} {...props}>
      {loading && <Loader2 size={15} className="animate-spin" />}
      {loading && loadingText ? loadingText : children}
    </Button>
  )
}
